import { render, staticRenderFns } from "./OsAppBar.vue?vue&type=template&id=50dcbf2e&scoped=true"
import script from "./OsAppBar.vue?vue&type=script&lang=ts"
export * from "./OsAppBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dcbf2e",
  null
  
)

export default component.exports